import { render, staticRenderFns } from "./newProfile.vue?vue&type=template&id=0d7267db&"
import script from "./newProfile.vue?vue&type=script&lang=js&"
export * from "./newProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports